<template>
    <!-- 属性模块 -->
    <div class="step" id="STEP-SWF">
        <div class="mask" v-show="mask_visible"></div>
        <!-- 信息组件 -->
        <div class="info" v-show="showInfo">
            <div class="main">当前画面时间： <span>{{step_data[0] == null ? 0 : parseFloat(step_data[0]).toFixed(1)}}</span> 秒</div>
            <div class="desc">注：根据所有元素最长时间播放</div>
        </div>
        <!-- 线组件 -->
        <div class="line" v-show="showInfo"></div>
        <!-- 树组件 -->
        <div class="tree"  v-if="step_res_data" onselectstart="return false">
            <!-- 列表 -->
            <div class="list" :class="hideLeft">
                <!-- 场景 -->
                <dl class="item" v-if="step_data.length >= 1"  @mouseover="itemMouseOver(step_type[0],'unselect')" @mouseout="itemMouseOut()">
                    <dt class="no" @click="handleSelectList('unselect',step_type[0],'')">
                        <div class="background" :class="{'active':mouse_over_unselect_item == step_type[0]}"></div>
                        <div class="inner">
                            <div class="icon">
                                <span class="bgc" :style="{ background: step_data[1] }" v-if="step_data[1].match('#')"></span>
                                <img :src="step_res_data[step_data[1]].thumb" v-if="step_res_data[step_data[1]] != null">
                            </div>
                            <div class="title" :title="scene_title" v-if="step_res_data[step_data[1]] != null">{{scene_title}}</div>
                            <div class="title" :title="step_data[1]" v-if="step_data[1].match('#')">{{step_data[1]}}</div>
                            <div class="icon-top_nav_delete_1" title="删除" v-show="mouse_over_unselect_item == step_type[0]" @click.stop="handleDelScene"></div>
                        </div>
                    </dt>
                </dl>
                <!-- 形象 -->
                <dl class="item" v-for="(item,index) in step_data[2]" v-if="step_data[2]" >
                    <dt class="no" @click="handleSelectList(item[0],step_type[1],'')" @mouseover="itemMouseOver(item,step_type[1])" @mouseout="itemMouseOut()"><!-- -->
                        <div class="background" :class="{'active':item == mouse_over_select_item}"></div>
                        <div class="inner">
                            <div class="el-icon-arrow-up" v-if="item[3].length > 0" v-show="item[item.length-1]" @click.stop="itemArrowClick(item,step_type[1],index)"></div>
                            <div class="el-icon-arrow-down" v-if="item[3].length > 0" v-show="!item[item.length-1]" @click.stop="itemArrowClick(item,step_type[1],index)"></div>
                            <div class="icon">
                                <img :src="getRoleData(item).thumb" v-if="step_res_data[item[1]] != null">
                                <!-- 组合的图片 -->
                                <img src="./top_combination.png" v-if="item[0][0] == 'C'">
                            </div>
                            <div class="title" :title="getRoleData(item).title" v-if="getRoleData(item) != null">{{getRoleData(item).text}}</div>
                            <!-- <div class="icon-top_nav_delete" @click.stop="handleDelMaterial(item[0])"></div> -->
                            <!--无动作时鼠标移入的显示(延时／添加动作／删除) -->
                            <div class="group-no-action" v-if="item[3].length == 0" v-show="item == mouse_over_select_item ">
                                <img class="el-icon-plus" v-show="showInfo" src="el-icon-plus"/>
                                <input class="no-action-input" v-show="showInfo" @click.stop="addDelayTime1"  @keyup.enter="addDelayTime(item,delay_input_value,step_type[1],index,'enter')" @blur="addDelayTime(item,delay_input_value,step_type[1],index,'')" v-model="delay_input_value" :placeholder="getDelayTime(item)"/><i v-show="showInfo">s</i>
                                <div class="add_step" title="添加动作" v-if="item[0][0] != 'C'" @click="addStep(item)" v-show="showInfo && item[0][0] != 'C'"></div>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--有动作时鼠标移入的显示(延时／删除) -->
                            <div class="group-action" v-if="item[3].length > 0" v-show="item == mouse_over_select_item">
                                <div class="el-icon-plus" v-show="showInfo"></div>
                                <input class="group-action-input" v-show="showInfo" @click.stop="addDelayTime1" @keyup.enter="addDelayTime(item,delay_input_value,step_type[1],index,'enter')" @blur.lazy="addDelayTime(item,delay_input_value,step_type[1],index,'')" v-model="delay_input_value" :placeholder="getDelayTime(item)"/><i v-show="showInfo">s</i>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--鼠标未移入时显示延时时长-->
                            <div class="group-action" v-if="parseFloat(item[4]).toFixed(1) > 0" v-show="item != mouse_over_select_item">
                                <div class="delay-time" style="color:#e2e2e2;">+ {{parseFloat(item[4]).toFixed(2)}}S</div>
                            </div>
                        </div>
                    </dt>
                    <dd v-for="action in item[3]" v-if="item[3].length > 0" v-show="item[item.length-1]" @mouseover="itemMouseOver(item,'action')" @mouseout="itemMouseOut()" @click="handleSelectList(item[0],step_type[1],'action')" ><!---->
                        <div class="background" :class="{'active':mouse_over && item == mouse_over_item}"></div>
                        <div class="inner" >
                            <div class="icon"><i class="icon-action"></i></div>
                            <div class="title" :title="getActionName(action)">{{getActionName(action)}}</div>
                            <!-- 鼠标移入的样式 -->
                            <div class="group" v-show="mouse_over && item == mouse_over_item" >
                                <!-- 移动动作可以编辑时长，非移动不显示 -->
                                <!-- <div class="time" v-if="action.length>3&&action[3]">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(1) : 0) : 0}}秒</div> -->
                                <input class="action_time"  v-if="action.length>3&&action[3]&&item[0][0]!='C'&&action[0].substring(0,2)!='74'" v-model="action_input_value" @click.stop="changeActionTime1" @change="changeActionTime(item[0],action_input_value,step_type[1],index)" @keyup.enter="changeActionTime(item[0],action_input_value,'enter',step_type[1],index)" @blur="changeActionTime(item[0],action_input_value,'',step_type[1],index)" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="no_combine" v-if="action.length>3&&action[3]">s</i>
                                <input class="action_time_C" v-if="action.length>3&&action[3]&&item[0][0]=='C'&&action[0].substring(0,2)!='74'" v-model="action_input_value" @click.stop="changeActionTime1" @change="changeActionTime(item[0],action_input_value,step_type[1],index)" @keyup.enter="changeActionTime(item[0],action_input_value,'enter',step_type[1],index)" @blur="changeActionTime(item[0],action_input_value,'',step_type[1],index)" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="combine" v-if="action.length>3&&action[3]&&item[0][0]=='C'">s</i>
                                <div class="icon-home" title="编辑" v-show="tab_type == 3 ? false : true" v-if="item[0][0] != 'C'&&action[0].substring(0,2)!='74'&&action_enable" @click.stop="handleEditAction(item[0], item[1], action[0], getActionName(action))"></div>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelAction(item[0], action[0])"></div>
                            </div>

                            <!--鼠标未移入的样式-->
                            <div class="group"  v-show="item != mouse_over_item">
                                <div class="time">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0}}S</div>
                            </div>
                        </div>
                    </dd>
                    <!-- 多层级(遮罩)-->
                    <!-- <dd v-for="(action,index) in item[3]" v-if="item[3].length > 0" v-show="item[item.length-1]" @mouseover="itemMouseOver(item,'action')" @mouseout="itemMouseOut()" @click="handleSelectList(item[0],step_type[1],'action')" >
                        <div class="inner" >
                            <div class="icon"><i class="icon-action"></i></div>
                            <div class="title" :title="getActionName(action)">{{getActionName(action)}}</div>
                           
                        </div>
                        <dd v-for="(action,index) in item[3]" v-if="item[3].length > 0" v-show="item[item.length-1]" @mouseover="itemMouseOver(item,'action')" @mouseout="itemMouseOut()" @click="handleSelectList(item[0],step_type[1],'action')" >
                            <div class="cover">
                                <div class="cover_icon" ><i class="icon-action"></i></div>
                                <div class="cover_title" :title="getActionName(action)">{{getActionName(action)}}</div>
                            </div>
                        </dd>
                    </dd>  -->
                </dl>

                <!-- 道具 -->
                <dl class="item" v-for="(item,index) in step_data[3]"  v-if="step_data[3]" >
                    <dt class="no" :data-alias="item[0]" @click="handleSelectList(item[0],step_type[2],'')" @mouseover="itemMouseOver(item,step_type[2])" @mouseout="itemMouseOut()">
                        <div class="background" :class="{'active':item == mouse_over_select_item}"></div>
                        <div class="inner">
                            <!-- <div class="arrow" v-if="item[3].length > 0" @click.stop="itemArrowClick(item,step_type[2],index)"></div> -->
                            <div class="el-icon-arrow-up" v-if="item[3].length > 0" v-show="item[item.length-1]" @click.stop="itemArrowClick(item,step_type[2],index)"></div>
                            <div class="el-icon-arrow-down" v-if="item[3].length > 0" v-show="!item[item.length-1]" @click.stop="itemArrowClick(item,step_type[2],index)"></div>
                            <div class="icon">
                                <img :src="step_res_data[item[1]].thumb" v-if="step_res_data[item[1]] != null">
                            </div>
                            <div class="title" :title="step_res_data[item[1]].title" v-if="step_res_data[item[1]] != null">{{tab_type == 3 ? "":""}}{{step_res_data[item[1]].title}}</div>
                            <!-- <div class="icon-top_nav_delete" @click.stop="handleDelProp(item[0])"></div> -->
                            <!--无动作时鼠标移入的显示(延时／添加动作／删除)-->
                            <div class="group-no-action" v-if="item[3].length == 0" v-show="item == mouse_over_select_item">
                                <img class="el-icon-plus" src="el-icon-plus" v-show="showInfo"/>
                                <input class="no-action-input" @click.stop="addDelayTime1" @keyup.enter="addDelayTime(item,delay_input_value,step_type[2],index,'enter')" @blur.lazy="addDelayTime(item,delay_input_value,step_type[2],index,'')" v-model="delay_input_value"  :placeholder="getDelayTime(item)" v-show="showInfo"/><i v-show="showInfo">s</i>
                                <div class="add_step" title="添加动作" @click="addStep(item)" v-show="showInfo"></div>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--有动作时鼠标移入的显示(延时／删除)-->
                            <div class="group-action" v-if="item[3].length > 0" v-show="item == mouse_over_select_item">
                                <div class="el-icon-plus" v-show="showInfo"></div>
                                <input class="group-action-input" @click.stop="addDelayTime1" @keyup.enter="addDelayTime(item,delay_input_value,step_type[2],index,'enter')" @blur.lazy="addDelayTime(item,delay_input_value,step_type[2],index,'')" v-model="delay_input_value" :placeholder="getDelayTime(item)" v-show="showInfo"/><i v-show="showInfo">s</i>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--鼠标未移入时显示延时时长-->
                            <div class="group-action" v-if="parseFloat(item[4]).toFixed(1) > 0" v-show="item != mouse_over_select_item">
                                <div class="delay-time" style="color:#e2e2e2;">+ {{parseFloat(item[4]).toFixed(2)}}S</div>
                            </div>
                        </div>
                    </dt>
                    <dd v-for="action in item[3]" v-if="item[3].length > 0" v-show="item[item.length-1]" @click="handleSelectList(item[0],step_type[2],'action')" @mouseover="itemMouseOver(item,'action')" @mouseout="itemMouseOut()">
                        <div class="background" :class="{'active':mouse_over && item == mouse_over_item}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-action"></i></div>
                            <div class="title" :title="getActionName(action)"> {{getActionName(action)}}</div>
                            <!-- 鼠标移入的样式 -->
                            <div class="group" v-show="mouse_over && item == mouse_over_item">
                                <!-- <div class="time">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(1) : 0) : 0}}秒</div> -->
                                <input class="action_time"  v-if="action.length>3&&action[3]&&item[0][0]!='C'&&action[0].substring(0,2)!='74'" v-model="action_input_value" @click.stop="changeActionTime1"  @keyup.enter="changeActionTime(item[0],action_input_value,'enter',step_type[2],index)" @blur="changeActionTime(item[0],action_input_value,'' ,step_type[2],index)" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="no_combine" v-if="action.length>3&&action[3]" v-show="showInfo">s</i>
                                <!-- <input class="action_time_C" v-if="action.length>3&&action[3]&&item[0][0]=='C'" v-model="action_input_value" @click.stop="changeActionTime1" @keyup.enter="changeActionTime(item[0],action_input_value,'enter')" @blur="changeActionTime(item[0],action_input_value,'')" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="combine" v-if="action.length>3&&action[3]&&item[0][0]=='C'" v-show="showInfo">s</i> -->
                                <div class="icon-home" v-if="action[0].substring(0,2)!='74'&&action_enable" title="编辑" v-show="showInfo" @click.stop="handleEditAction(item[0], item[1], action[0], getActionName(action))"></div>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelAction(item[0], action[0])"></div>
                            </div>
                            <!--鼠标未移入的样式-->
                            <div class="group"  v-show="item != mouse_over_item">
                                <div class="time">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0}}S</div> 
                            </div>
                        </div>
                    </dd>
                </dl>
                <!-- 气泡 -->
                <dl class="item" v-for="(item,index) in step_data[4]" >
                    <dt class="no" :data-alias="item[0]" @click="handleSelectList(item[0],step_type[3],'')" @mouseover="itemMouseOver(item,step_type[3])" @mouseout="itemMouseOut()">
                        <div class="background" :class="{'active':item == mouse_over_select_item}"></div>
                        <div class="inner">
                            <!-- <div class="arrow" v-if="item[3].length > 0" @click.stop="itemArrowClick(item,step_type[3],index)"></div> -->
                            <div class="el-icon-arrow-up" v-if="item[3].length > 0" v-show="item[item.length-1]" @click.stop="itemArrowClick(item,step_type[3],index)"></div>
                            <div class="el-icon-arrow-down" v-if="item[3].length > 0" v-show="!item[item.length-1]" @click.stop="itemArrowClick(item,step_type[3],index)"></div>
                            <div class="icon">
                                <img :src="step_res_data[item[1]].thumb" v-if="step_res_data[item[1]] != null">
                            </div>
                            <div class="title" :title="step_res_data[item[1]].title" v-if="step_res_data[item[1]] != null">{{step_res_data[item[1]].title}}</div>
                            <!-- <div class="icon-top_nav_delete" @click.stop="handleDelBubble(item[0])"></div> -->
                            <!--无动作时鼠标移入的显示(延时／添加动作／删除) <img src="./add_step_normal.png">-->
                            <div class="group-no-action" v-if="item[3].length == 0" v-show="item == mouse_over_select_item">
                                <img class="el-icon-plus" src="el-icon-plus" v-show="showInfo"/>
                                <input class="no-action-input" @click.stop="addDelayTime1" @keyup.enter="addDelayTime(item,delay_input_value,step_type[3],index,'enter')" @blur="addDelayTime(item,delay_input_value,step_type[3],index,'')" v-model="delay_input_value"  :placeholder="getDelayTime(item)" v-show="showInfo"/><i v-show="showInfo">s</i>
                                <div class="add_step" title="添加动作" @click="addStep(item)" v-show="showInfo"></div>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--有动作时鼠标移入的显示(延时／删除)-->
                            <div class="group-action" v-if="item[3].length > 0" v-show="item == mouse_over_select_item">
                                <div class="el-icon-plus" v-show="showInfo"></div>
                                <input class="group-action-input" @click.stop="addDelayTime1" @keyup.enter="addDelayTime(item,delay_input_value,step_type[3],index,'enter')" @blur="addDelayTime(item,delay_input_value,step_type[3],index,'')" v-model="delay_input_value"  :placeholder="getDelayTime(item)" v-show="showInfo"/><i v-show="showInfo">s</i>
                                <div class="icon-top_nav_delete_1" title="删除" @click.stop="handleDelMaterial(item[0])"></div>
                            </div>
                            <!--鼠标未移入时显示延时时长-->
                            <div class="group-action" v-if="parseFloat(item[4]).toFixed(1) > 0" v-show="item != mouse_over_select_item">
                                <div class="delay-time" style="color:#e2e2e2;">+ {{parseFloat(item[4]).toFixed(2)}}S</div>
                            </div>
                        </div>
                    </dt>
                    <dd v-for="action in item[3]" v-if="item[3].length > 0" v-show="item[item.length-1]" @click="handleSelectList(item[0],step_type[3],'action')" @mouseover="itemMouseOver(item,'action')" @mouseout="itemMouseOut()">
                        <div class="background" :class="{'active':mouse_over && item == mouse_over_item}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-action"></i></div>
                            <div class="title" :title="getActionName(action)">{{getActionName(action)}}</div>
                            <!-- 鼠标移入的样式 -->
                            <div class="group" v-show="mouse_over && item == mouse_over_item">
                                <!-- <div class="time">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(1) : 0) : 0}}秒</div> -->
                                <!-- <input class="action_time" v-if="action.length>3&&action[3]" v-model="action_input_value" @click.stop="changeActionTime1" @change="changeActionTime(item[0],action_input_value)" @keyup.enter="changeActionTime(item[0],action_input_value)" :placeholder="getActionTime(action)"/><i v-if="action.length>3&&action[3]">s</i> -->
                                <input class="action_time"  v-if="action.length>3&&action[3]&&item[0][0]!='C'&&action[0].substring(0,2)!='74'" v-model="action_input_value" @click.stop="changeActionTime1"  @keyup.enter="changeActionTime(item[0],action_input_value,'enter',step_type[3],index)" @blur="changeActionTime(item[0],action_input_value,'',step_type[3],index)" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="no_combine" v-if="action.length>3&&action[3]" v-show="showInfo">s</i>
                                <!-- <input class="action_time_C" v-if="action.length>3&&action[3]&&item[0][0]=='C'" v-model="action_input_value" @click.stop="changeActionTime1" @keyup.enter="changeActionTime(item[0],action_input_value,'enter')" @blur="changeActionTime(item[0],action_input_value,'')" :placeholder="getActionTime(action)" v-show="showInfo"/><i class="combine" v-if="action.length>3&&action[3]&&item[0][0]=='C'" v-show="showInfo">s</i> -->
                                <div class="icon-home" v-if="action[0].substring(0,2)!='74'&&action_enable" title="编辑" v-show="showInfo" @click.stop="handleEditAction(item[0], item[1], action[0], getActionName(action))"></div>
                                <div class="icon-top_nav_delete_1" @click.stop="handleDelAction(item[0], action[0])"></div>
                            </div>
                            <!--鼠标未移入的样式-->
                            <div class="group"  v-show="item != mouse_over_item">
                                <div class="time">{{action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(2) : 0) : 0}}S</div>
                            </div>
                        </div>
                    </dd>
                </dl>
                <!-- 字幕 -->
                <dl class="item" v-if="step_data[5]" @mouseover="itemMouseOver(step_type[4],'unselect')" @mouseout="itemMouseOut()">
                    <dt class="no" @click="handleSelectList('unselect',step_type[4],'')">
                        <div class="background" :class="{'active':mouse_over_unselect_item == step_type[4]}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-nav_text"></i></div>
                            <div class="title">{{step_data[5]}}</div>
                            <div class="icon-top_nav_delete_1" title="删除" v-show="mouse_over_unselect_item == step_type[4]" @click.stop="handleDelSubtitle"></div>
                        </div>
                    </dt>
                </dl>
                <!-- 镜头 -->
                <dl class="item" v-if="step_data[6] != 0 && step_data[6] != undefined" @mouseover="itemMouseOver(step_type[5],'unselect')" @mouseout="itemMouseOut()">
                    <dt class="no" @click="handleSelectList('unselect',step_type[5],'')">
                        <div class="background" :class="{'active':mouse_over_unselect_item == step_type[5]}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-nav_scene"></i></div>
                            <div class="title" v-if="step_data[6] >= 0">镜头</div>
                            <div class="title" v-if="step_data[6] == -1">镜头跟随</div>
                            <div class="group">
                                <div class="time"  style="margin-right:-15px;" v-if="step_data[6] >= 0" v-show="mouse_over_unselect_item != step_type[5]">{{parseFloat(step_data[6]).toFixed(2)}}S</div>
                                <div class="icon-top_nav_delete_1" title="删除" v-show="mouse_over_unselect_item == step_type[5]" @click.stop="handleDelCamera"></div>
                            </div>
                        </div>
                    </dt>
                </dl>
                <!-- 配音 -->
                <dl class="item" v-if="step_data[7] && step_data[7][0] != undefined" @mouseover="itemMouseOver(step_type[6],'unselect')" @mouseout="itemMouseOut()">
                    <dt class="no" @click="handleSelectList('unselect',step_type[6],'')">
                        <div class="background" :class="{'active':mouse_over_unselect_item == step_type[6]}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-mic"></i></div>
                            <div class="title">配音</div>
                            <div class="time">{{parseFloat(step_data[7][1]).toFixed(2)}}S</div>
                            <div class="icon-top_nav_delete_1" title="删除" v-show="mouse_over_unselect_item == step_type[6]" @click.stop="handleDelDub"></div>
                        </div>
                    </dt>
                </dl>
                <!-- 背景音 -->
                <dl class="item" v-if="step_data[8] && step_data[8].length > 0" @mouseover="itemMouseOver(step_type[7],'unselect')" @mouseout="itemMouseOut()">
                    <dt class="no" @click="handleSelectList('unselect',step_type[7],'')">
                        <div class="background" :class="{'active':mouse_over_unselect_item == step_type[7]}"></div>
                        <div class="inner">
                            <div class="icon"><i class="icon-nav_voice"></i></div>
                            <div class="title" :title="action_bgm_data.title">{{action_bgm_data.title}}</div>
                            <div class="icon-top_nav_delete_1" title="删除" v-show="mouse_over_unselect_item == step_type[7]" @click.stop="handleDelBgm"></div>
                        </div>
                    </dt>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
import index from 'vue';
import Vue from 'vue';
var step_data = []
var vm = new Vue({
  step_data: step_data,
})
    export default {
        // 组件
        components: {
        },
        // 计算
        computed: {
            scene_title () {
                // return this.step_data[1].match('#') ? '场景：' + this.step_data[1] : '场景：' + this.step_res_data[this.step_data[1]].title
                return this.step_data[1].match('#') ?  this.step_data[1] :  this.step_res_data[this.step_data[1]].title
            },
            scene_pic () {
                return this.step_data[1].match('#') ? this.step_data[1] : this.step_res_data[this.step_data[1]].thumb
            },
            // 场景编辑器／动作编辑器改变list的top
            hideLeft () {
                if(this.showInfo){
                    return 'position-top65'
                }else{
                    return 'position-top0'
                }
            },
        },
         data () {
            return {
                platform: this.$route.query.platform,
                tab_type: '',
                init: '',
                showInfo: true,
                edit_visible: false,
                activeNames: ['1', '2', '3', '4'],
                step_data: [],
                step_res_data: [],
                select_id: '',
                dialog_create_action_visible: false,
                form_create_action: {
                    title: ''
                },
                formLabelWidth: 100,
                title: '',
                id: '',
                type: 'action',
                team_id: '',
                folder_id: '',
                token: '',
                // -------------------------------------------------- [ FLASH ] --------------------------------------------------
                has_token: '',
                // 遮罩层
                mask_visible: true,
                action_bgm_data:'',
                // shift按下时可以多选
                shiftDown:false,
                // 用于标记是否是形象 道具 气泡
                isunselect:false,
                // 多选形象／道具／气泡数组
                multiple_select_data:[],
                single_select_data:[],
                // 多选点击是否已选
                multiple_select_exist:false,
                // 多选多选的场景／背景音等数组
                multiple_unselect_data:[],
                // 多选点击场景／背景音是否已选
                multiple_unselect_exist:false,
                // 多选形象／道具／气泡的动作上一级
                multiple_select_type:[],
                // 多选形象／道具／气泡的动作
                multiple_select_action:[],
                // 多选形象／道具／气泡的动作是否已选
                multiple_select_action_exist:false,
                // 步属性能否选择
                stepSelected:false,
                step_type:['scene','material','prop','bubble','text','camera','dub','bgm'],
                handleSelectClick:false,
                // 鼠标移入的标记
                mouse_over:false,
                // 鼠标移入动作的item
                mouse_over_item:'',
                // 鼠标移入的unselect类型（场景／字幕等）
                mouse_over_unselect_item:'',
                // 鼠标移入的select类型（形象／道具／气泡等）
                mouse_over_select_item:'',
                // 形象／道具／气泡的延时时长
                delay_input_value:'',
                // 动作时长输入框的值
                action_input_value:'',
                // 标记是否有字幕
                step_text_value:'',
                // 标记是否有镜头
                step_camera_value:'',
                // 标记是否有配音
                step_dub_value:'',
                // 延时输入框是否获得焦点
                step_delay_input_focus:false,
                // 移动动作输入框是否获得焦点
                step_action_input_focus:false,
                // 回车延时／动作时长
                step_enter_down:false,
                // 动作是否可以编辑
                action_enable:false,
                // 版本信息
                // identity: {
                //     name: '',
                //     limittime: '',
                //     permission:'',
                // },
            }
        },
        created ()
         {
             let component = this
             document.onkeydown = function (e){
                let key = window.event.keyCode
                if (key == 16){// shift按键
                    component.shiftDown = true
                    //console.log('document.onkeydown')
                }
            },
            document.onkeyup = function (e){
                let key = window.event.keyCode
                if (key == 16){// shift按键
                    component.shiftDown = false
                    //console.log('document.onkeyup')
                    // component.multiple_select_data = []
                    // component.multiple_select_exist = false
                }
            }
        },
        methods: {
            // 鼠标移入
            itemMouseOver(item, type){
                if(this.step_enter_down) {
                    this.step_enter_down = false
                    return
                }
                // 鼠标移入的下标
                let mouse_over_index = -1
                this.mouse_over = true
                // 场景／声音／字幕／镜头类型
                if(type == 'unselect'){
                    this.mouse_over_unselect_item = item
                    let index = this.step_data[2].length + this.step_data[3].length + this.step_data[4].length
                    // 场景
                    if(item == this.step_type[0]){
                        mouse_over_index = 0
                    }
                    // 字幕
                    else if(item == this.step_type[4]){
                         mouse_over_index =  index + 1
                    }
                    // 镜头
                    else if(item == this.step_type[5]){
                       mouse_over_index = this.step_text_value?(index+2):(index+1)
                    }
                    // 配音
                    else if(item == this.step_type[6]){
                        // 有字幕
                        if(this.step_data[5]){
                            // 有镜头
                            if(this.step_data[6] != 0){
                                mouse_over_index = index + 2
                            }
                            else{
                                mouse_over_index = index + 1
                            }
                        }
                        else{
                            // 有镜头
                            if(this.step_data[6] != 0){
                                mouse_over_index = index + 1
                            }
                            else{
                                mouse_over_index = index
                            }
                        }
                    }
                    // 背景音
                    else if(item == this.step_type[7]){
                        // 有字幕
                        if(this.step_data[5]){
                            index+=1
                            // 有镜头
                            if(this.step_data[6] != 0){
                                index+=1
                                // 有配音
                                if(this.step_data[7]&& this.step_data[7][0] != undefined){
                                    index+=1
                                }
                            }
                            else{
                                 // 有配音
                                if(this.step_data[7]&&this.step_data[7][0] != undefined){
                                    index+=1
                                }
                            }
                        }
                        else{
                            // 有镜头
                            if(this.step_data[6] != 0){
                                index+=1
                                // 有配音
                                if(this.step_data[7]&&this.step_data[7][0] != undefined){
                                    index+=1
                                }
                            }
                        }
                         mouse_over_index = index+1
                    }
                   
                    // console.log('背景音 ===》' + mouse_over_index + index)
                    // this.changeBackground(mouse_over_index,'mouse_over')
                }else{
                    // 移入的是动作
                    if(type == 'action'){
                        this.mouse_over_item = item
                        this.mouse_over_select_item = ''
                        // 输入框获得焦点的时候不需要 item[3][0][1]
                        if(this.step_action_input_focus)return
                        this.action_input_value = parseFloat(item[3][0][1]).toFixed(2) 
                    }else{
                        // 移入的是形象／道具／气泡
                        this.mouse_over_item = ''
                        this.mouse_over_select_item = item
                        // 输入框获得焦点的时候不需要 item[4]
                        // console.log(' ======== ' + this.step_delay_input_focus)
                        if(this.step_delay_input_focus)return
                        this.delay_input_value = item[4]
                    }
                }
            },
            // 鼠标移出
            itemMouseOut(){
                this.mouse_over = false
                this.mouse_over_item = ''
                this.mouse_over_unselect_item = ''
                this.mouse_over_select_item = ''
            },
            //返回鼠标移入的下标
            getMouseOverIndex(item, type){
                let mouse_over_index = -1
                // 形象类型
                if(type == this.step_type[1]){
                    // 获取选中形象的下标
                    for(var j=0;j<this.step_data[2].length;j++){
                        // 比对alias
                        if(item == this.step_data[2][j]){
                            mouse_over_index = j
                        }
                    }
                }
                else if(type == this.step_type[2]){
                    // 获取选中道具的下标
                    for(var j=0;j<this.step_data[3].length;j++){
                        // 比对alias
                        if(item == this.step_data[3][j]){
                            let index = this.step_data[2].length - 1
                            mouse_over_index = j+index+1
                        }
                    }
                }
                else if(type == this.step_type[3]){
                    // 获取选中气泡的下标
                    for(var j=0;j<this.step_data[4].length;j++){
                        // 比对alias
                        if(item == this.step_data[4][j]){
                            let index = this.step_data[2].length  + this.step_data[3].length
                            mouse_over_index = j+index
                        }
                    }
                }
                else if (type == 'action'){
                    // 获取选中形象的下标
                    for(var j=0;j<this.step_data[2].length;j++){
                        // 比对alias
                        if(item == this.step_data[2][j]){
                            mouse_over_index = j
                        }
                    }
                    if(mouse_over_index >= 0){
                        return mouse_over_index
                    }
                    // 获取选中道具的下标
                    for(var j=0;j<this.step_data[3].length;j++){
                        // 比对alias
                        if(item == this.step_data[3][j]){
                            let index = this.step_data[2].length - 1
                            mouse_over_index = j+index+1
                        }
                    }
                    if(mouse_over_index >= 0){
                        return mouse_over_index
                    }
                    // 获取选中气泡的下标
                    for(var j=0;j<this.step_data[4].length;j++){
                        // 比对alias
                        if(item == this.step_data[4][j]){
                            let index = this.step_data[2].length  + this.step_data[3].length
                            mouse_over_index = j+index
                        }
                    }
                }
                return mouse_over_index
            },
            // 获取形象／动作／气泡的延时
            getDelayTime(item){
                return item[4] ? parseFloat(item[4]).toFixed(1) : 0
            },
            // 添加延时
            addDelayTime1(){
                this.step_delay_input_focus = true
            },
            // 添加延时 name区分enter／blur
            addDelayTime(item, val, type, index, name){
                if(name != 'enter'){
                    this.step_delay_input_focus = false
                    //console.log('this.step_delay_input_focus = false')
                }else{
                    this.mouse_over_select_item = ''
                    this.step_enter_down = true
                }
                let idx = 4
                if(val>10)val='10.00'
                if(type == this.step_type[1]){
                    vm.$set(vm.step_data[2][index],idx,val)
                }else if(type == this.step_type[2]){
                    vm.$set(vm.step_data[3][index],idx,val)
                }else if (type == this.step_type[3]){
                    vm.$set(vm.step_data[4][index],idx,val)
                }
                let platform = this.$route.query.platform
                let step_scene_6_48 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 48,
                    protoBytesType: 'proto.com.proto.scene.MBundleValue',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MBundleValue(), {
                        setBundle: item[0],
                        setValue:val,
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_48)

            },
            // 箭头点击
            itemArrowClick(item ,type, index){
                let idx = item.length-1
                item[idx] = !item[idx]
                if(type == this.step_type[1]){
                    vm.$set(vm.step_data[2][index],idx,item[idx])
                }else if(type == this.step_type[2]){
                    vm.$set(vm.step_data[3][index],idx,item[idx])
                }else if (type == this.step_type[3]){
                    vm.$set(vm.step_data[4][index],idx,item[idx])
                }
            },
            // 添加动作
            addStep(item){
                // console.log('添加动作 ===>' + JSON.stringify(item))
                let platform = this.$route.query.platform
                let step_core_6_43 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 43,
                    protoBytesType: 'proto.com.proto.scene.MBundleAction',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MBundleAction(), {
                        setBundlealias: item[0],
                        setActionid: ''
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_core_6_43);
            },
            // 获取动作的时长
            getActionTime(action){
                return action.length >= 2 ? (action[1] ? parseFloat(action[1]).toFixed(1) : 0) : 0
            },
            // action_input
            changeActionTime1(){
                this.step_action_input_focus = true
                // console.log('action_input ==>')
            },
            // 改变动作时长
            changeActionTime(alias, val, name, type, index){
                //console.log('改变动作时长' + val + alias)
                if(name != 'enter'){
                    this.step_action_input_focus = false
                }else{
                    this.mouse_over_item = ''
                    this.step_enter_down = true
                }

                let idx = 1
                if(val>10)val='10.00'
                if(type == this.step_type[1]){
                    vm.$set(vm.step_data[2][index][3][0],idx,val)
                }else if(type == this.step_type[2]){
                    vm.$set(vm.step_data[3][index][3][0],idx,val)
                }else if (type == this.step_type[3]){
                    vm.$set(vm.step_data[4][index][3][0],idx,val)
                }
                //console.log('--------> ' + JSON.stringify(this.step_data[4][index]) + val)
                let platform = this.$route.query.platform
                let step_scene_6_49 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 49,
                    protoBytesType: 'proto.com.proto.scene.MBundleValue',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MBundleValue(), {
                        setBundle: alias,
                        setValue:val,
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_49)
            },
            getActionName(action) {
                return this.step_res_data[action[0]] ? this.step_res_data[action[0]].title : ((action.length > 2 && action[2]) ? action[2] : "自定义动作");
            },
            getRoleData(originData){
                var alias = originData[0];
                var id = originData[1];
                var showPrefix = this.tab_type !== 3;
                var data, prefix;
                if(alias[0] === "C"){
                    prefix = "组合";
                    var text = originData[2] || "";
                    data = {title : text};
                } else {
                    prefix = "";
                    data = this.step_res_data[id];
                }
                if(data){
                    prefix = showPrefix ? prefix : ""
                    data.text = prefix + data.title;
                }
                return data;
            },

            handleEditAction (bundlealias, bundle, id, name) {
                this.name = name
                this.editBundleId = bundle
                let platform = this.$route.query.platform
                let step_core_6_43 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 43,
                    protoBytesType: 'proto.com.proto.scene.MBundleAction',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MBundleAction(), {
                        setBundlealias: bundlealias,
                        setActionid: id
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_core_6_43);
            },
            // 创建副本
            handleFolderGroupCopy (id, name) {
                let platform = this.$route.query.platform
                let URL = process.env.HOST + '/pro/api/matter/copy'
                name += '-副本'
                let params = 'title=' + name  + '&id=' + id + '&type=' + this.type + '&team_id=' + this.team_id + '&folder_id=' + this.folder_id
                let headers = {
                    'token': this.token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
                this.AJAX.post(URL, headers, params, platform).then((data)=>{
                    let platform = this.$route.query.platform
                    // protobuf 打包
                    let MTabData  = new proto.com.proto.s.MTabData()
                    let MTabDataTabType = proto.com.proto.s.MTabData.TabType.ACTION
                    // protobuf 打包格式
                    MTabData.setType(MTabDataTabType)
                    MTabData.setId(data.result.id)
                    MTabData.setTitle(name)
                    MTabData.setTeamid(this.team_id)
                    MTabData.setTeamname(this.team_name)
                    MTabData.setData(this.editBundleId)
                    // protobuf 序列化
                    let protoBytes = MTabData.serializeBinary()
                    // Uint8Array 转换 Array
                    let protoBytesArray = Array.from(protoBytes)
                    let step_core_1_5 = {
                        packageId: 0,
                        senderId: STEP,
                        senderName: STEP_NAME,
                        receiverId: CORE,
                        receiverName: CORE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 1,
                        messageId: 5,
                        protoBytesType: 'proto.com.proto.s.MTabData',
                        protoBytes: protoBytesArray
                    }
                    // 发送消息
                    Protocol.sender(platform, step_core_1_5)
                }).catch((err)=>{
                    this.$message({
                        message: err.msg||err.message,
                        type: 'error'
                    })
                })
                this.dialog_create_action_visible = false
            },
            handleDelScene () {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'scene'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelSubtitle () {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'subtitle'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelCamera () {
                let  platform = this.$route.query.platform

                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'camera'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelBubble () {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'bubble'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelBgm () {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'bgm'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelDub () {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'dub'
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelMaterial (alias) {
                console.log("handleDelMaterial, alias:=", alias);
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'material',
                        setAlias: alias
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelProp (alias) {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'prop',
                        setAlias: alias
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelBubble (alias) {
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'bubble',
                        setAlias: alias
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleDelAction (alias, id) {
                console.log("======handleDelAction,", alias, id);
                let  platform = this.$route.query.platform
                let step_scene_6_32 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 32,
                    protoBytesType: 'proto.com.proto.scene.MDeleteItem',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MDeleteItem(), {
                        setType: 'action',
                        setAlias: alias,
                        setId: id
                    })
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_32)
            },
            handleSelectList (alias, type, name) {
                //console.log('handleSelectList ===> ' + alias)
                this.handleSelectClick = true
                let  platform = this.$route.query.platform
                // 单选情况 选择的是场景／背景音等
                if(alias == 'unselect' && this.shiftDown == false){
                    // this.single_select_data = []
                    this.multiple_select_data = []
                    this.multiple_select_action = []
                    this.multiple_select_type = []
                    let step_scene_6_28 = {
                        packageId: 0,
                        senderId: STEP,
                        senderName: STEP_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 28,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, step_scene_6_28)
                    // 点"镜头"行：额外请求镜头数据（senderId=STEP），核心侧同步数据并打开镜头面板
                    if(type == this.step_type[5]){
                        let step_scene_6_6 = {
                            packageId: 0,
                            senderId: STEP,
                            senderName: STEP_NAME,
                            receiverId: SCENE,
                            receiverName: SCENE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 6,
                            messageId: 6,
                            protoBytesType: '',
                            protoBytes: []
                        }
                        Protocol.sender(platform, step_scene_6_6)
                    }
                }
                // 单选情况 选择的是形象／道具／气泡
                else if (alias != 'unselect' && this.shiftDown == false){
                    this.multiple_select_data = []
                    this.multiple_select_action = []
                    this.multiple_select_type = []
                    if(name == 'action'){
                        // 单选选择的是动作
                        this.multiple_select_action.push(alias)
                    }else{
                        // 单选选择的是动作上一级
                        this.multiple_select_type.push(alias)
                    }

                    this.multiple_select_data.push(alias)
                    let step_scene_6_27 = {
                            packageId: 0,
                            senderId: STEP,
                            senderName: STEP_NAME,
                            receiverId: SCENE,
                            receiverName: SCENE_NAME,
                            timeFlag: new Date().getTime(),
                            sessionId: 6,
                            messageId: 27,
                            protoBytesType: 'proto.com.proto.s.MStrings',
                            protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MStrings(), {
                                setValueList: this.multiple_select_data,//this.single_select_data,
                            })
                        }
                        // 发送消息
                        Protocol.sender(platform, step_scene_6_27)
                }
                // 多选情况 选择的是场景／背景音等
                else if (alias == 'unselect' && this.shiftDown){
                    this.isunselect = true
                    this.multiple_unselect_exist = false
                    let pop_index = -1
                    for(var i =0; i<this.multiple_unselect_data.length;i++){
                        if(this.multiple_unselect_data[i] == type){
                            this.multiple_unselect_exist = true
                            pop_index = i
                        }
                    }
                    if(!this.multiple_unselect_exist){
                        this.multiple_unselect_data.push(type)
                        //console.log('unselect 不存在')
                    }else{
                        this.multiple_unselect_data.splice(pop_index,1)
                        //console.log('unselect 已存在')
                    }
                    //console.log('this.multiple_unselect_data ===> ' + JSON.stringify(this.multiple_unselect_data) + 'ff' + type)
                }
                // 多选情况 选择的是形象／道具／气泡
                else if (alias != 'unselect' && this.shiftDown){
                    this.isunselect = false
                    this.multiple_select_exist = false
                    // 用来标记动作的上一级是否选中
                    let muitiple_select_type_exist = false
                    if(name == 'action'){
                        this.multiple_select_action_exist = false
                        let pop_action_index = -1
                        // 如果动作数组中不存在，则添加
                        for(var i =0;i<this.multiple_select_action.length;i++){
                            // 存在
                            if(this.multiple_select_action[i] == alias){
                                this.multiple_select_action_exist = true
                                pop_action_index = i
                            }
                        }
                        if(!this.multiple_select_action_exist){
                            this.multiple_select_action.push(alias)
                            // console.log('选择的动作不存在' + alias)
                        }else{
                            this.multiple_select_action.splice(pop_action_index,1)
                            // console.log('选择的动作存在' + alias)
                        }

                        //  需要动作确认上一级是否选中
                        for(var i =0;i<this.multiple_select_type.length;i++){
                            if(this.multiple_select_type[i] == alias){
                                muitiple_select_type_exist = true
                            }
                        }
                    }
                    // 点击的时动作的上一级
                    else{
                        // let exist = false
                        let pop_index = -1
                        for(var i =0;i<this.multiple_select_type.length;i++){
                            if(this.multiple_select_type[i] == alias){
                                muitiple_select_type_exist = true
                                pop_index = i
                            }
                        }
                        if(!muitiple_select_type_exist){
                            this.multiple_select_type.push(alias)
                            // muitiple_select_type_exist = true
                             //console.log('动作上一级选中' + JSON.stringify(this.multiple_select_type))
                        }else{
                            this.multiple_select_type.splice(pop_index,1)
                            // muitiple_select_type_exist = false
                             //console.log('动作上一级取消' + JSON.stringify(this.multiple_select_type) + '<===> ' + JSON.stringify(this.multiple_select_data))
                        }

                        // 确认下一级是否选中
                        this.multiple_select_action_exist = false
                        for(var i =0;i<this.multiple_select_action.length;i++){
                            // 存在
                            if(this.multiple_select_action[i] == alias){
                                this.multiple_select_action_exist = true
                            }
                        }
                    }
                   
                    let pop_index = -1
                    for(var i =0; i<this.multiple_select_data.length;i++){
                        if(this.multiple_select_data[i] == alias ){//&& name != 'action'
                            if(!muitiple_select_type_exist){

                            }else{
                                this.multiple_select_exist = true
                                pop_index = i
                            }
                            
                        }
                    }
                     // 如果点的是动作
                    if(name == 'action'){
                        // 上一级没有点击 同时动作不存在
                        if(!muitiple_select_type_exist && !this.multiple_select_action_exist){
                            this.multiple_select_data.push(alias)
                             //console.log('action === 上一级没有选中，点击动作')
                        }
                        // 上一级没有点击 同时动作存在
                        else if(!muitiple_select_type_exist && this.multiple_select_action_exist){ 
                            let pop_index = -1
                            for(var i =0; i<this.multiple_select_data.length;i++){
                                if(this.multiple_select_data[i] == alias){
                                    pop_index = i
                                }
                            }
                            this.multiple_select_data.splice(pop_index,1)
                            //console.log('action === 上一级没有选中，取消动作')
                        }
                        else if(muitiple_select_type_exist && !this.multiple_select_action_exist){ 
                            // this.multiple_select_data.push(alias)
                             //console.log('action === 上一级选中，没有选中动作')
                        }
                        else if(muitiple_select_type_exist && this.multiple_select_action_exist){ 
                            // this.multiple_select_data.push(alias)
                             //console.log('action === 上一级选中，选中动作')
                        }
                    }
                    else{
                        // 上一级没有点击 同时动作不存在
                        if(!muitiple_select_type_exist && !this.multiple_select_action_exist){
                            this.multiple_select_data.push(alias)
                             console.log('上一级选中，动作也没有选中')
                        }
                        // 上一级没有点击 同时动作存在
                        else if(!muitiple_select_type_exist && this.multiple_select_action_exist){ 
                            console.log('上一级选中，动作选中')
                        }
                        else if(muitiple_select_type_exist && !this.multiple_select_action_exist){ 
                             console.log('上一级取消选中，动作也没有选中' + JSON.stringify(this.multiple_select_data))
                             let pop_index = -1
                            for(var i =0; i<this.multiple_select_data.length;i++){
                                if(this.multiple_select_data[i] == alias){
                                    pop_index = i
                                }
                            }
                            this.multiple_select_data.splice(pop_index,1)
                            console.log('选择的形象道具气泡 ==> '+ JSON.stringify(this.multiple_select_type))
                        }
                        else if(muitiple_select_type_exist && this.multiple_select_action_exist){ 
                             console.log('上一级取消选中，动作选中')
                        }
                    }

                    console.log('this.multiple_select_data ===> ' + JSON.stringify(this.multiple_select_data))
                    let step_scene_6_27 = {
                        packageId: 0,
                        senderId: STEP,
                        senderName: STEP_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 27,
                        protoBytesType: 'proto.com.proto.s.MStrings',
                        protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MStrings(), {
                            setValueList: this.multiple_select_data,
                        })
                    }
                    // 发送消息
                    Protocol.sender(platform, step_scene_6_27)
                }
                
                // if (alias == 'unselect') {
                //     if(this.shiftDown) {
                //         // this.isunselect = true
                //         // this.stepSelected = false
                //         return
                //     }
                //     // this.isunselect = true
                //     let step_scene_6_28 = {
                //         packageId: 0,
                //         senderId: STEP,
                //         senderName: STEP_NAME,
                //         receiverId: SCENE,
                //         receiverName: SCENE_NAME,
                //         timeFlag: new Date().getTime(),
                //         sessionId: 6,
                //         messageId: 28,
                //         protoBytesType: '',
                //         protoBytes: []
                //     }
                //     // 发送消息
                //     Protocol.sender(platform, step_scene_6_28)
                // } else {
                //     // console.log('handleSelectList ===> select')
                //     // this.isunselect = false
                //     if(!this.shiftDown){
                //         this.single_select_data = []
                //         this.single_select_data.push(alias)
                //         let step_scene_6_27 = {
                //             packageId: 0,
                //             senderId: STEP,
                //             senderName: STEP_NAME,
                //             receiverId: SCENE,
                //             receiverName: SCENE_NAME,
                //             timeFlag: new Date().getTime(),
                //             sessionId: 6,
                //             messageId: 27,
                //             protoBytesType: 'proto.com.proto.s.MStrings',
                //             protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MStrings(), {
                //                 setValueList: this.single_select_data,
                //             })
                //         }
                //         // 发送消息
                //         Protocol.sender(platform, step_scene_6_27)
                //     }else{
                //         console.log('handleSelectList ===> ' + alias)
                //         this.multiple_select_exist = false
                //         let pop_index = -1
                //         for(var i =0; i<this.multiple_select_data.length;i++){
                //             if(this.multiple_select_data[i] == alias){
                //                 this.multiple_select_exist = true
                //                 pop_index = i
                //             }
                //         }
                //         if(!this.multiple_select_exist){
                //             this.multiple_select_data.push(alias)
                //         }else{
                //             this.multiple_select_data.splice(pop_index,1)
                //         }
                //         console.log('this.multiple_select_data ===> ' + JSON.stringify(this.multiple_select_data))
                //         let step_scene_6_27 = {
                //             packageId: 0,
                //             senderId: STEP,
                //             senderName: STEP_NAME,
                //             receiverId: SCENE,
                //             receiverName: SCENE_NAME,
                //             timeFlag: new Date().getTime(),
                //             sessionId: 6,
                //             messageId: 27,
                //             protoBytesType: 'proto.com.proto.s.MStrings',
                //             protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MStrings(), {
                //                 setValueList: this.multiple_select_data,
                //             })
                //         }
                //         // 发送消息
                //         Protocol.sender(platform, step_scene_6_27)
                //     }

                    // let step_scene_6_27 = {
                    //     packageId: 0,
                    //     senderId: STEP,
                    //     senderName: STEP_NAME,
                    //     receiverId: SCENE,
                    //     receiverName: SCENE_NAME,
                    //     timeFlag: new Date().getTime(),
                    //     sessionId: 6,
                    //     messageId: 27,
                    //     protoBytesType: 'proto.com.proto.s.MString',
                    //     protoBytes: Protocol.serializeBinary(new proto.com.proto.s.MString(), {
                    //         setValue: alias,
                    //     })
                    // }
                    // // 发送消息
                    // Protocol.sender(platform, step_scene_6_27)
                // }
            },
            handlePostList (id) {
                
                let param = this.ListByIdCache.check(id)
                // console.log('step =====> listById ' + JSON.stringify(param))
                if(Object.keys(param.cache).length > 0){
                    this.step_res_data = param.cache
                    for(var item in this.step_res_data){
                        if(this.step_res_data[item].type == 'bgm'){
                            this.action_bgm_data = this.step_res_data[item]
                        }
                    }
                    this.temp()
                }
                
                if(param.newId.length) {
                    let URL = process.env.HOST + '/pro/api/matter/listByIds'
                    let params = 'id=' + param.newId.toString()
                    let headers = {
                        'token': this.has_token,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                    this.AJAX.post(URL, headers, params).then((data)=>{
                        if(Object.keys(data.result).length > 0){
                            let temp_data = {}
                            for(var id in data.result){
                                temp_data[id] = data.result[id]
                            }

                            for(var id in this.step_res_data){
                                temp_data[id] = this.step_res_data[id]
                            }
                            this.step_res_data = temp_data
                            for(var item in this.step_res_data){
                                if(this.step_res_data[item].type == 'bgm'){
                                    this.action_bgm_data = this.step_res_data[item]
                                }
                            }
                            // 将新的id data添加到缓存中
                            this.ListByIdCache.cacheIdData(data.result)
                            
                        }

                        // this.step_res_data = data.result
                        // // console.log('this.step_res_data ==>' + JSON.stringify(this.step_res_data))
                        // //  this.ListByIdCache.cacheIdData(data.result)
                        // console.log('步属性请求数据 ==>')
                        // for(var item in this.step_res_data){
                        //     if(this.step_res_data[item].type == 'bgm'){
                        //         this.action_bgm_data = this.step_res_data[item]
                        //     }
                        // }

                        this.temp()
                    }).catch((err)=>{
                        this.$message({
                            message: err.msg||err.message,
                            type: 'error'
                        })
                    })
                }

            },

            temp(){
                let dts = $('.list dt')
                let dds = $('.list dd')
                let _this = this;
                dts.each(function(index) {
                    $(this).on('click', function () {
                        // isunselect == true 选择的是场景／背景音 多选情况
                        if(_this.shiftDown){ // _this.isunselect == false &&
                            // 多选 选择的是场景／背景音等
                            if(_this.isunselect){
                                    if(_this.multiple_unselect_exist){
                                    $(this).css('background', 'none')
                                    // console.log("多选 1===> ")
                                }else{
                                    // 按下shift 同时，鼠标点击形象道具气泡类型
                                    $(this).css('background', '#3d3d3d')
                                    // console.log("多选 2===> ")
                                }
                            }else{
                                    if(_this.multiple_select_exist){
                                    $(this).css('background', 'none')
                                    // console.log("多选 3===> ")
                                }else{
                                    // 按下shift 同时，鼠标点击形象道具气泡类型
                                    $(this).css('background', '#3d3d3d')
                                    // console.log("多选 4===> ")
                                }
                            }
                        }
                        else {
                            $(this).css('background', '#3d3d3d')
                                .parent().siblings().find('dt').css('background', 'none')
                                .parent().siblings().find('dd').css('background', 'none') 
                        }

                    })
                })

                dds.each(function (index) {
                    $(this).on('click', function () {
                        if(_this.shiftDown){
                            // 多选情况下，选择的是动作
                            if(_this.multiple_select_action_exist){
                                $(this).css('background', 'none')
                            }else{
                                $(this).css('background', '#3d3d3d')
                            }
                        }else{
                                let dts = $('.list dt')
                                let dds = $('.list dd')
                                dts.each(function(index) {
                                    $(this).css('background', 'none')
                                    .parent().siblings().find('dt').css('background', 'none')
                                    .parent().siblings().find('dd').css('background', 'none')
                                    
                                })

                                $(this).css('background', '#3d3d3d')
                                .parent().siblings().find('dd').css('background', 'none')
                                .parent().siblings().find('dt').css('background', 'none')
                        }
                    })
                })
            },

            changeBackground(idx,type){
                let dts = $('.list dt')
                let dds = $('.list dd')
                dts.each(function(index) {
                    if(idx == index){
                        let color = type == 'click'?'#3d3d3d':'#d8d8d8'
                        $(this).css('background', color)
                    }
                })
            },
            clearBackground(){
                let dts = $('.list dt')
                let dds = $('.list dd')
                dts.each(function(index) {
                    $(this).css('background', 'none')
                })
                dds.each(function(index) {
                    $(this).css('background', 'none')
                })
            },

            // 获取用户版本权限
            // handleGetIdentity()
            // {
            //     let URL = process.env.HOST + '/pro/api/user/identity'
            //     this.$http({
            //         method: 'GET',
            //         url: URL,
            //         headers: {
            //             token: this.token
            //         },
            //         emulateJSON: true
            //     }).then((response) => {
            //         let res = response.body
            //         this.identity = {
            //             name: res.result.name,
            //             limittime: res.result.limittime,
            //             permission:res.result.permission,
            //         }
            //         // console.log('获取用户版本权限 ==> ' + JSON.stringify(res))
            //     })
            // },
        },
        watch: {
            // 延时／动作输入框只能输入数字
            'delay_input_value':function(){
                //  /[^\.\d]/g
                if(!this.showInfo) return
                this.delay_input_value = this.delay_input_value.replace(/[^\.\d]/g,'')
                if(this.delay_input_value > 10.0){
                    this.delay_input_value = '10.00'
                }
            },
            'action_input_value':function(){
                if(!this.showInfo) return
                this.action_input_value = this.action_input_value.replace(/[^\.\d]/g,'')
                if(this.action_input_value > 10.0){
                    this.action_input_value = '10.00'
                }
            }
            
        },
        mounted () {

            let platform = this.$route.query.platform
            let _this = this
            // 模块 STEP
            // 模块初始化
            Protocol.onSocketInit(platform, STEP_NAME, STEP)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, STEP_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, STEP_NAME, STEP)
            // 接收消息
            Protocol.receiver(platform, STEP_NAME)
            window[STEP_NAME].domReady = () => {
                // alert(STEP_NAME)
                let step_core_1_1 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 1,
                    protoBytesType: 'proto.com.proto.s.MToken',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, step_core_1_1)

                let step_core_1_11 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: CORE,
                    receiverName: CORE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 1,
                    messageId: 11,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, step_core_1_11)

                let step_scene_6_2 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 2,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_2)
                // 检查场景是否加载完成
                let step_scene_6_26 = {
                    packageId: 0,
                    senderId: STEP,
                    senderName: STEP_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 26,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, step_scene_6_26)
            }
            window[STEP_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {
                if (sessionId == 1 && messageId == 10) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.s.MAlertBack', protoBytes).array
                    if (arr[1] == 'ok') {
                        _this.handleFolderGroupCopy (arr[0], _this.name)
                    }
                }else if (sessionId == 1 && messageId == 12) { // 同步团队型信息
                    let tabObj = Protocol.deserializeBinary('proto.com.proto.s.MTabData', protoBytes).toObject();
                    let tabType = tabObj.type;
                    _this.tab_type = tabType;
                    _this.team_id = tabObj.teamid ? tabObj.teamid : ''
                    _this.team_name = tabObj.teamname ? tabObj.teamname : ''
                    _this.folder_id = tabObj.folder ? tabObj.folder : ''
                    _this.showInfo = tabType == 3 ? false : true

                    _this.mask_visible = true
                    _this.step_data = []
                    _this.step_res_data = []

                }else if(sessionId == 1 && messageId == 2) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array
                    _this.token = arr[0]
                }else if (sessionId == 2 && messageId == 5) {// 切步 {"step":2,"page":0,"time":0,"duration":0.875}
                    let arr = Protocol.deserializeBinary('proto.com.proto.editortimeline.MStepIndex', protoBytes).toObject();
                    let step_scene_6_2 = {
                        packageId: 0,
                        senderId: STEP,
                        senderName: STEP_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 2,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, step_scene_6_2)
                }else if (sessionId == 6 && messageId == 1) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.scene.MSelected', protoBytes).array
                     console.log('6_1 ===> 1' + JSON.stringify(arr) + '===')
                    _this.stepSelected = arr.length>0?_this.stepSelected = arr[0]:_this.stepSelected = false
                    
                    if(arr.length > 1 && arr[0]){
                        if(_this.handleSelectClick) {
                            _this.handleSelectClick = false
                            console.log('右侧步属性点击 '+ _this.handleSelectClick)
                            return
                        }
                        _this.handleSelectClick = false
                        console.log('左侧点击 '+ _this.handleSelectClick)
                        // 选中的下标数组
                        let select_index = []
                        // 选中的别名数组
                        let select_data = []
                        // 便利选中的形象/道具/气泡
                        for(var i=0;i<arr[1].length;i++){
                            // 形象类型
                            if(arr[1][i][1] == 'material'){
                                // 获取选中形象的下标
                                for(var j=0;j<_this.step_data[2].length;j++){
                                    // 比对alias
                                    if(arr[1][i][3] == _this.step_data[2][j][0]){
                                        console.log('形象的下标 ===> ' + j + '>>>')
                                        select_index.push(j)
                                    }
                                }
                                // 将别名添加进去
                                select_data.push(arr[1][i][3])
                            }
                            else if(arr[1][i][1] == 'prop'){
                                console.log('道具的数据 ===> ' + JSON.stringify(_this.step_data[3]))
                                // 获取选中道具的下标
                                for(var j=0;j<_this.step_data[3].length;j++){
                                    // 比对alias
                                    if(arr[1][i][3] == _this.step_data[3][j][0]){
                                        let index = _this.step_data[2].length - 1
                                        console.log('道具的下标 ===> ' + j+index+1 + '>>>')
                                        select_index.push(j+index+1)
                                    }
                                }
                                // 将别名添加进去
                                select_data.push(arr[1][i][3])
                            }
                            else if(arr[1][i][1] == 'bubble'){
                                // 获取选中气泡的下标
                                for(var j=0;j<_this.step_data[4].length;j++){
                                    // 比对alias
                                    if(arr[1][i][3] == _this.step_data[4][j][0]){
                                        let index = _this.step_data[2].length  + _this.step_data[3].length
                                        console.log('气泡的下标 ===> ' + j+index + '>>>')
                                        select_index.push(j+index)
                                    }
                                }
                                // 将别名添加进去
                                select_data.push(arr[1][i][3])
                            }
                        }
                        if(select_index){
                            _this.multiple_select_data = select_data
                            _this.multiple_select_type = select_data
                            console.log('选中的下标 === ' + select_index + '<=此时的multiple_select_data==> ' + _this.multiple_select_data)
                            select_data = []
                            setTimeout(function(){
                                _this.clearBackground()
                                for(var i =0;i<select_index.length;i++){
                                    _this.changeBackground(select_index[i]+1,'click')
                                }
                            }, 1)
                        
                        }

                    }else if (arr.length > 1 && !arr[0]){
                        _this.clearBackground()
                        _this.multiple_select_data = []
                        _this.multiple_select_type = []
                    }
                    _this.handleSelectClick = false
                }else if (sessionId == 6 && messageId == 5) {
                    _this.init = 'complete'
                    _this.mask_visible = false
                    //console.log('[' + STEP_NAME + '][COMPLETE]')
                    let step_scene_6_2 = {
                        packageId: 0,
                        senderId: STEP,
                        senderName: STEP_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 2,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, step_scene_6_2)
                }else if (sessionId == 6 && messageId == 3) {
                    let arr = Protocol.deserializeBinary('proto.com.proto.scene.MStepDetails', protoBytes).array
                    let temp = Protocol.deserializeBinary('proto.com.proto.scene.MStepDetails', protoBytes).toObject()
                    _this.step_data = arr
                    //console.log('STEPs 333- ', JSON.stringify(arr))
                    _this.action_enable = temp.actioneditable
                    _this.step_text_value = arr[5]?1:0
                    _this.step_camera_value = arr[6]?1:0
                    _this.step_dub_value = (arr[7] && arr[7][0] != undefined)?1:0
                    let ids = []
                    _this.edit_visible = arr[9]
                    // 场景
                    if (!arr[1].match('#')) {
                        if(arr[1]) ids.push(arr[1])
                    }
                    // 形象
                    if (arr[2].length > 0) {
                        for (let i = 0; i < arr[2].length; i++) {
                             // 标记列表展开状态
                            let arrow_item_display = true
                            _this.step_data[2][i].push(arrow_item_display)
                            if(arr[2][i][1]) ids.push(arr[2][i][1])
                            if (arr[2][i][3].length > 0) {
                                for (let j = 0; j < arr[2][i][3].length; j++) {
                                    if(arr[2][i][3][j][0]) ids.push(arr[2][i][3][j][0])
                                }
                            }
                        }
                    }
                    
                    // 道具
                    if (arr[3].length > 0) {
                        for (let i = 0; i < arr[3].length; i++) {
                            // 标记列表展开状态
                            let arrow_item_display = true
                            _this.step_data[3][i].push(arrow_item_display)
                            if(arr[3][i][1]) ids.push(arr[3][i][1])
                            if (arr[3][i][3].length > 0) {
                                for (let j = 0; j < arr[3][i][3].length; j++) {
                                    if(arr[3][i][3][j][0]) ids.push(arr[3][i][3][j][0])
                                }
                            }
                        }
                    }
                    // 气泡
                    if (arr[4].length > 0) {
                        for (let i = 0; i < arr[4].length; i++) {
                            // 标记列表展开状态
                            let arrow_item_display = true
                            _this.step_data[4][i].push(arrow_item_display)
                            if(arr[4][i][1]) ids.push(arr[4][i][1])
                            if (arr[4][i][3].length > 0) {
                                for (let j = 0; j < arr[4][i][3].length; j++) {
                                    if(arr[4][i][3][j][0]) ids.push(arr[4][i][3][j][0])
                                }
                            }
                        }
                    }
                    // 配音
                    if (arr.length >= 8){
                        if (arr[7].length > 0) {
                            if (arr[7][0] != undefined) {
                                if(arr[7][0]) ids.push(arr[7][0])
                            }
                        }
                    }
                    // 背景音
                    if (arr.length >= 9){
                        if (arr[8].length > 0) {
                            if(arr[8][0]) ids.push(arr[8][0])
                        }
                    }
                    //console.log("id", ids.length)
                    vm.step_data = _this.step_data
                    ids.length > 0 ? _this.handlePostList(ids) : _this.step_res_data = []                   
                }else if(sessionId == 1 && messageId == 2){
                    let is_token = Protocol.deserializeBinary('proto.com.proto.s.MToken', protoBytes).array
                    _this.has_token = is_token[0]
                }else if(sessionId == 1 && messageId == 13){// 锁定模块
                    _this.mask_visible = true
                }else if(sessionId == 1 && messageId == 14){ // 解除锁定
                    _this.mask_visible = false
                }
            }
        }
    }
</script>
<style lang="stylus" scoped>
  .step
    background:#505050//#3d3d3d
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    // overflow: auto
    .mask
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      width: 280px
      background: #3a3a3a//rgba(255, 255, 255,.8)
      z-index: 1
    .info
      padding: 15px
      right:0
      .main
        color: #e2e2e2//#505050
        padding-bottom: 10px
        span
          color: #f00
      .desc
        color: #a6a6a6
    .tree
      padding-top: 5px
      padding-bottom: 10px
      .list
        position: absolute
        // top: 65px
        right: 0
        bottom: 0
        left: 0
        overflow: auto
        .item
          padding: 0
          dt,
          dd
            padding-left: 0
            font-size: 12px
            line-height: 30px
            position: relative
            color: #4c4c4c
            margin-top: 5px
            cursor: pointer
          dt
            .background
              position:absolute
              top:0
              left:0
              right:0
              bottom:0 
            .active
              background:#6d6d6d//#d8d8d8
            .inner
              white-space: nowrap
              text-overflow: ellipsis
              font-size: 12px
              transform: scale(0.8)
              padding-left: 35px
            .time
              position: absolute
              right: -20px
              top: 0
              color: #999
            .arrow
              cursor: pointer
              position: absolute
              left: -25px
              top: 7px
              width: 16px
              height: 16px
              background: url(./arrow.png) no-repeat 50% 50%
            .el-icon-arrow-up
              cursor: pointer
              position: absolute
              left: -25px
              top: 7px
              width: 32px
              height: 32px
            .el-icon-arrow-down
              cursor: pointer
              position: absolute
              left: -25px
              top: 7px
              width: 32px
              height: 32px  
            .icon
              padding: 3px
              background: #fff
              width: 24px
              height: 24px
              position: absolute
              top: 1px
              left: 0
              border-radius: 3px
              .bgc
                position: absolute
                top: 3px
                right: 3px
                bottom: 3px
                left: 3px
                border-radius: 3px
              i
                font-size: 24px
                position: absolute
                top: 4px
                left: 2px
              img
                height: 24px
                display: block
                margin: 0 auto
            .icon-top_nav_delete_1
              position: absolute
              right:-23px
              top: 2px
              height: 25px
              width:25px
              line-height: 25px
              color: #333
              font-size: 22px
              background: url(./step_delete_normal.png) no-repeat 50% 50% 
              &:hover {
                    background: url(./step_delete_hover.png) no-repeat 50% 50%
              }
              &:active {
                    background: url(./step_delete_click.png) no-repeat 50% 50% 
              }
            .group-no-action
            //   background:blue
              position: absolute
              right: -25px
              top: 0
              div
                float: left
                height: 30px
                line-height: 30px
                color: #333
                // padding: 0 3px
                // background:red
              .el-icon-plus
               position:relative
               float: left
               height: 10px
               width:10px
               line-height:10px
               color:gray
               right:53px
               top:10px
              .no-action-input
                position:relative
                // background:green
                width:32px
                height:14px
                right:50px
                top:1px
                border-radius:4px
                &:focus {
                    border: 1px solid #7AB3F6
                }
              .add_step  
                position:absolute
                // background:green
                font-size:22px
                right:20px
                height:25px
                width:25px
                top:2px
                background: url(./step_step_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_step_hover.png) no-repeat 50% 50%
                }
                &:active {
                    background: url(./step_step_click.png) no-repeat 50% 50% 
                }
              .icon-top_nav_delete_1
                position:absolute
                right: 0px
                top: 2px
                height: 25px
                line-height: 25px
                width:25px
                color: #333
                font-size: 22px
                // background:green
                background: url(./step_delete_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_delete_hover.png) no-repeat 50% 50%
                }
                &:active {
                    background: url(./step_delete_click.png) no-repeat 50% 50% 
                }
               i
                font-size: 12px
                height:30px
                top:0
                color:gray
                position: absolute
                left: -5px 
            .group-action
            //   background:blue
              position: absolute
              right: -25px
              top: 0
              div
                float: left
                height: 30px
                line-height: 30px
                color: #333
              .el-icon-plus
               position:relative
               width:10px
               line-height:10px
               color:gray
               margin-top:10px 
               right:33px
              .group-action-input
                position:relative
                // background:green
                width:32px
                height:14px
                right:30px
                top:1px
                border-radius:4px
                &:focus {
                    border: 1px solid #7AB3F6
                }
              .icon-top_nav_delete_1
                position:absolute
                right: 0px
                top: 2px
                height: 25px
                line-height: 25px
                width:25px
                color: #333
                font-size: 22px
                // background:green
                background: url(./step_delete_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_delete_hover.png) no-repeat 50% 50%
                }
                &:active { 
                    background: url(./step_delete_click.png) no-repeat 50% 50% 
                }
               i
                font-size: 12px
                height:30px
                top:0
                color:gray
                // background:red
                position: absolute
                left: 15px  
            .group
              position: absolute
              right: -3px
              top: 0
              div
                float: left
                height: 25px
                line-height: 25px
                color: #333
                padding: 0 3px
              .time
                right: 0
                color:#e2e2e2
              .icon-top_nav_delete_1
                position: absolute
                line-height: 30px
                height:25px
                width:20px
                // background:green
                font-size: 22px
                background: url(./step_delete_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_delete_hover.png) no-repeat 50% 50%
                }
                &:active {
                    background: url(./step_delete_click.png) no-repeat 50% 50% 
                }
            .delay-time
                position: absolute
                // background:green
                width:30px
                height:20px 
                top:2px
                right:15px 
                padding-right: 7px 
          .no
            padding-left: 0px
            .icon
              position: absolute
              top: 0
              left: 0
              border-radius: 3px
              img
                width: 24px
                height: 24px
                display: block
            .title
              color:#e2e2e2
              &:hover{
                //   color:red
              }
              span
                color: #f00  
          dd
            padding-left: 62px
            .background
              position:absolute
              top:0
              left:0
              right:0
              bottom:0 
            .active
              background:#6d6d6d//#d8d8d8
            .inner
              white-space: nowrap
              text-overflow: ellipsis
              font-size: 12px
              transform: scale(0.8)
            .title
              width: 120px
              white-space: nowrap
              text-overflow: ellipsis
              overflow: hidden
              color:#e2e2e2
              &:hover{
                //   color:green
              }
            .icon
              border-radius: 3px
              padding: 3px
              background: #fff
              width: 24px
              height: 24px
              position: absolute
              top: 0
              left: -40px
              i
                font-size: 24px
                position: absolute
                top: 4px
                left: 4px
              img
                height: 24px
                display: block
                margin: 0 auto
            .group
            //   background:blue
              position: absolute
              right: -15px
              top: 0
              div
                float: left
                height: 30px
                line-height: 30px
                color: #333
              .time
                padding-right: 5px
                color:#e2e2e2
                // background:red
              .icon-top_nav_delete_1
                position:absolute
                right: 0px
                top: 2px
                height: 25px
                line-height: 25px
                width:25px
                color: #333
                font-size: 22px
                background: url(./step_delete_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_delete_hover.png) no-repeat 50% 50%
                }
                &:active {
                    background: url(./step_delete_click.png) no-repeat 50% 50% 
                }
              .icon-home
                position:absolute
                line-height: 25px
                font-size: 22px
                width:25px
                height:25px
                right:20px
                top:2px
                background: url(./step_editor_normal.png) no-repeat 50% 50% 
                &:hover {
                    background: url(./step_editor_hover.png) no-repeat 50% 50%
                }
                &:active {
                    background: url(./step_editor_click.png) no-repeat 50% 50% 
                }
              .action_time
                position:relative
                width:32px
                height:14px
                right:50px
                top:1px
                border-radius:4px
                &:focus {
                    border: 1px solid #7AB3F6
                }
              .no_combine 
                font-size: 12px
                height:30px
                top:0
                color:gray
                // background:red
                position: absolute
                left: -15px  
              .action_time_C 
                position:relative
                width:32px
                height:14px
                right:30px
                top:1px
                // background:red
                border-radius:4px
                &:focus {
                    border: 1px solid #7AB3F6
                }
              .combine 
                font-size: 12px
                height:30px
                top:0
                color:gray
                // background:red
                position: absolute
                left: 7px   
            // .cover
            //     // background:red  
            //     position: relative
            //     left:10px
            //     right:0
            //     height:30px
            //  .cover_title
            //     width: 120px
            //     white-space: nowrap
            //     text-overflow: ellipsis
            //     overflow: hidden
            //     position: absolute
            //     // background: blue
            //     top:1px
            //     left:21px
            //     right:0
            //     font-size: 12px
            //     -webkit-transform: scale(0.8)
            //  .cover_icon
            //     border-radius: 3px
            //     padding: 3px
            //     background: #fff
            //     width: 18px
            //     height: 18px
            //     position: relative
            //     top:3px
            //     left:0
            //     // background: green
            //     i
            //         font-size: 20px
            //         position: absolute
            //         top: 3px
            //         left: 3px
            //     img
            //         display: block
            //         margin: 0 auto

      .position-top65
        top:65px   
      .position-top0
        top:0   
</style>



// WEBPACK FOOTER //
// Step.vue?3444560f